function generatedMutationId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `suggestion-overrides-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function createLegacySuggestionOverridesApi({
  client,
  mutationIdFactory = generatedMutationId,
} = {}) {
  let webserviceClient = client || null;
  let revision = 0;
  let pendingMutation = null;

  function getClient() {
    if (!webserviceClient) {
      // eslint-disable-next-line global-require
      webserviceClient = require('util/appUtils').wsClient;
    }
    return webserviceClient;
  }

  return {
    async load(shopId) {
      const response = await getClient().prepareRequest(
        'GET',
        `/system/shop/${encodeURIComponent(shopId)}/customization/search/suggestion-overrides`,
      );
      revision = Number(response?.revision || 0);
      pendingMutation = null;
      return response;
    },

    async publish(shopId, rules) {
      const signature = JSON.stringify(rules);
      if (!pendingMutation || pendingMutation.signature !== signature) {
        pendingMutation = { signature, id: mutationIdFactory() };
      }
      const response = await getClient().prepareRequest(
        'POST',
        `/system/shop/${encodeURIComponent(shopId)}/customization/search/suggestion-overrides`,
        {
          body: {
            rules,
            expected_revision: revision,
            client_mutation_id: pendingMutation.id,
          },
        },
      );
      revision = Number(response?.revision || revision);
      pendingMutation = null;
      return response;
    },
  };
}
